import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: 'operator/login',
    method: 'post',
    params: data
  })
}

// 客服账号信息列表
export function operatorinfo(data) {
  return request({
    url: 'operator/info',
    method: 'post',
    params: data
  })
}

//  修改客服账号密码
export function setpassword(data) {
  return request({
    url: '/operator/resetpass',
    method: 'post',
    params: data
  })
}

// 添加客服账号
export function addAcc(data) {
  return request({
    url: '/operator/addaccount',
    method: 'post',
    params: data
  })
}

// 删除客服账号
export function delAcc(data) {
  return request({
    url: '/operator/delaccount',
    method: 'post',
    params: data
  })
}
